<script lang="ts">
    
    import { Route, Router } from "svelte-navigator";
    import AccountForm from "./AccountForm.svelte";
    import AccountsList from "./AccountsList.svelte";

</script>


<Router primary={false}>

    <Route path="/" component={AccountsList} />
    <Route path="editar/:accountId" component={AccountForm} />

</Router>
